import React, { Component, useState, useEffect } from 'react';
import Header from "components/Header";
import Information from "components/Information";
import Controls from "components/Controls";
import UnityWindow from "components/UnityWindow";
import appData from 'appData.json'
import AdComponent from 'components/AdComponent'


const GamePage: React.FC<> = () => {

  const [gameState, setGameState] = useState(null)
  const [reloadCounter, setReloadCounter] = useState(0)
  const [playerName, setPlayerName] = useState('Player 1')
  const [unloadUnityComponent, setUnloadUnityComponent] = useState(true)

  useEffect(() => {
    const loadData = async () => {
      // Load data from local storage
      let savedGameState = JSON.parse(localStorage.getItem('gameState'));
      if (savedGameState) {
        setGameState(savedGameState);
        setUnloadUnityComponent(false)
      } else {
        // Check for VR headset support
        if (navigator.xr) {
          const supported = await navigator.xr.isSessionSupported('immersive-vr');
          if (supported) {
            setGameState('webXR');
          } else {
            setGameState('default');
          }
        } else {
          setGameState('default');
        }
        setUnloadUnityComponent(false)
      }
    };

    loadData();
  }, []);

  function updateBuild(newState){
    setUnloadUnityComponent(true)
    setGameState(newState)
    setReloadCounter(reloadCounter + 1)
    setUnloadUnityComponent(false)
    // Save data to local storage
    localStorage.setItem('gameState', JSON.stringify(newState));
  }

  return (
    <div style={{
      marginTop: 'calc(100px + 10vw)',
      minHeight: '100vh', 
      display: 'flex', 
      flexDirection: 'column', 
      justifyContent: 'center', 
      alignItems: 'center'
    }}>
      {/*<AdComponent isFreeVersion={true} />*/}
      {appData ? (
        <>
          {/* <Header data={appData.main} /> */}
          
          {/* Temporarily disabling Unity component for maintenance */}
          
          {!unloadUnityComponent &&
            <UnityWindow 
              updateBuild={updateBuild}
              gameState={gameState}
              playerName={playerName}
              setPlayerName={setPlayerName}
            />
          } 

          {/* Display maintenance message */}
          {/* 
          <div style={{
            textAlign: 'center',
            padding: '50px',
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#333',
            backgroundColor: '#f8d7da',
            border: '2px solid #dc3545',
            borderRadius: '10px'
          }}>
            🚧 The game is currently under maintenance for the day. Please check back later! 🚀
          </div>
          */}
          {/* <Controls data={appData.controls} />
          <Information data={appData.information} /> */}
        </>
      ) : null}
    </div>
  );
};

export default GamePage;